var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdaptiveLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.818 22v-2.857C6.52 16.166 3 14.572 3 10c0-4.57 2.727-8.056 8.182-8c3.927.042 7.636 2.286 7.636 6.858L21 12.286c0 2.286-2.182 2.286-2.182 2.286s.546 5.714-4.364 5.714V22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 12a2 2 0 1 0 0-4a2 2 0 0 0 0 4"
  }), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: ".3 2",
    d: "M11 13a3 3 0 1 0 0-6a3 3 0 0 0 0 6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptiveLearning);
export default __webpack_public_path__ + "static/media/adaptiveLearning.891567a0a4bcd876cff443d3ad356a87.svg";
export { ForwardRef as ReactComponent };